import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { selectHasRole, selectUserId } from '../../../security/state/auth/selector'
import EVENT_COLOR_LIST from './event-color'

const SORT_ORDER = {
    'btn-primary': 0,
    'btn-success': 1,
    'btn-info': 2,
    'btn-warning': 3,
    'btn-danger': 4,
    'btn-default': 5,
}


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectProcessFlowVisible = (state) => {
    return selectOwnState(state).processFlowVisible
}

export const selectHasNoFollowUpTask = state => {
    return selectOwnState(state).noFollowUp
}

export const selectTask = (state) => {
    return selectOwnState(state).task
}

export const selectIsTaskReadOnly = (state) => {
    const task = selectTask(state)
    if (!task) {
        return true
    }
    if (task.status === 'finished') {
        return true
    }
    const currentUserId = selectUserId(state)
    const { assignedToUserId } = task

    const accessable = selectHasRole(state, task.role) && (assignedToUserId === null || assignedToUserId === currentUserId)
    return !accessable
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectTaskName = (state) => {
    const task = selectTask(state)
    if (!task) {
        return null
    }
    return task.name
}

export const selectTaskId = (state) => {
    const task = selectTask(state)
    if (!task) {
        return null
    }
    return task.id
}

export const selectRole = (state) => {
    const task = selectTask(state)
    if (!task) {
        return null
    }
    return task.role
}


export const selectProcessInstance = (state) => {
    const task = selectTask(state)
    return task ? task.processInstance : null
}

export const selectProcessInstanceId = (state) => {
    const task = selectTask(state)
    return task ? task.processInstanceId : null
}


export const selectCurrentState = (state) => {
    const processInstance = selectProcessInstance(state)
    if (!processInstance) {
        return null
    }
    return processInstance.currentState
}

export const selectAvailableTransitionList = (state) => {
    const currentState = selectCurrentState(state)
    if (!currentState) {
        return null
    }
    let transitionList = currentState.transitionList.filter(transition => {
        return !!transition.eventName
    })

    transitionList = transitionList.map(transition => {
        const className = EVENT_COLOR_LIST[transition.eventName] || 'btn-primary'
        return {
            ...transition,
            className,
            sortOrder: SORT_ORDER[className],
        }
    })

    transitionList.sort((a, b) => {
        return a.sortOrder - b.sortOrder
    })

    return transitionList
}

export const selectValidationMessageList = state => {
    return selectOwnState(state).validationMessageList
}

export const selectHasPreviousRetainerRefinementProcess = (state) => {
    const task = selectTask(state)
    if (!task) {
        return null
    }

    const salesOrderList = task.objectDetail.customer.salesOrderList
    return salesOrderList.filter(salesOrder => salesOrder.type === 'retainer-refinement' ||  salesOrder.type === 'retainer-refinement-new').length > 0
}

export const selectOnyxId = (state) => {
    const task = selectTask(state)
    if (!task) {
        return null
    }

    return task.objectDetail.customer.onyxId
}

export const selectOnyxServer = (state) => {
    const task = selectTask(state)
    if (!task) {
        return null
    }

    return task.objectDetail.customer.onyxServer
}



// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/selector.js